export default "__VITE_ASSET__D1nh1A9H__"